import React from "react";
import { Hero } from "../../reusables/index";
import { heroData } from "../../../assets/data/ourStoryData";

export default function OurStoryHero(props) {
	return <Hero data={heroData} />;
}
